import { useTranslation } from "@i18n";
import { useState } from "react";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ToggleSwitchComponent from "@CubeComponents/form/ToggleSwitchComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import Text from "@CubeComponents/html/Text/Text";

type DuplicateTakeoffModalProps = {
  closeDuplicateTakeoffModal: () => void;
  copyTakeoff: (linkMeasurements: boolean, linkItems: boolean) => Promise<void> | void;
  isDuplicateMeasurement: boolean;
};

function DuplicateTakeoffModal({
  closeDuplicateTakeoffModal,
  copyTakeoff,
  isDuplicateMeasurement,
}: DuplicateTakeoffModalProps) {
  const { t } = useTranslation();
  const [linkItems, setLinkItems] = useState(false);
  const [linkMeasurements, setLinkMeasurements] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const handleSubmitDuplicateTakeoff = async () => {
    setIsButtonLoading(true);
    await copyTakeoff(linkMeasurements, linkItems);
    setIsButtonLoading(false);
  };
  const header = () => (
    <div className="w-full flex justify-between">
      <span>{isDuplicateMeasurement ? t("Duplicate Measurement") : t("Duplicate Takeoff")}</span>
    </div>
  );

  const content = () => (
    <div className="flex flex-col gap-3 pe-1">
      <div className="flex justify-between">
        <Text>{`${isDuplicateMeasurement ? t("Link Takeoffs") : t("Link Measurements")}`}</Text>
        <ToggleSwitchComponent onChange={() => setLinkMeasurements((prev) => !prev)} checked={linkMeasurements} />
      </div>
      {!isDuplicateMeasurement && (
        <div className="flex justify-between">
          <Text>{t("Link Items")}</Text>
          <ToggleSwitchComponent onChange={() => setLinkItems((prev) => !prev)} checked={linkItems} />
        </div>
      )}
    </div>
  );

  const footer = () => (
    <div className="flex gap-4">
      <ButtonComponent
        onClick={handleSubmitDuplicateTakeoff}
        buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
        loading={isButtonLoading}
      >
        <Text>{t("Duplicate")}</Text>
      </ButtonComponent>
      <ButtonComponent
        onClick={closeDuplicateTakeoffModal}
        buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        disabled={isButtonLoading}
      >
        <Text>{t("Cancel")}</Text>
      </ButtonComponent>
    </div>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      headerTitle={header()}
      onCancel={isButtonLoading ? undefined : closeDuplicateTakeoffModal}
      modelContent={content()}
      footerContent={footer()}
      width="28.125rem"
    />
  );
}

export default DuplicateTakeoffModal;
